import { X, Navigation } from 'lucide-react';

export default function QuickNavigation({
  isOpen = false,
  onToggle = () => {},
  navigationSections = [],
  scrollToSection = () => {},
  activeSection = null,
}) {
  return (
    <>
      {/* Floating Button */}
      <button
        onClick={onToggle}
        className="fixed bottom-44 right-1 sm:w-16 sm:h-16 w-16 h-16 bg-gradient-to-tr from-cyan-600 to-blue-600 text-white rounded-full shadow-md flex items-center justify-center z-50 transition-transform duration-300 hover:scale-110"
        aria-label="Hurtig Navigation"
      >
        <div className="relative w-5 h-5 sm:w-6 sm:h-6">
          <Navigation
            className={`absolute inset-0 w-full h-full transition-all duration-500 ${
              isOpen ? 'opacity-0 scale-50 rotate-[360deg]' : 'opacity-100 scale-100 animate-pulse'
            }`}
          />
          <X
            className={`absolute inset-0 w-full h-full transition-all duration-500 ${
              isOpen ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-50 -rotate-[360deg]'
            }`}
          />
        </div>
      </button>

      {/* Popup Box */}
      <div
        className={`fixed bottom-20 right-16 w-56 sm:w-64 z-40 transition-all duration-500 ease-out ${
          isOpen ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-3 opacity-0 scale-95 pointer-events-none'
        }`}
      >
        <div className="bg-slate-900 rounded-xl shadow-xl border border-cyan-700/30 overflow-hidden">
          
          {/* Header */}
          <div
            className={`bg-gradient-to-r from-cyan-600 to-blue-600 text-white p-2.5 text-center text-sm sm:text-base font-bold relative transition-all duration-500 rounded-t-xl ${
              isOpen ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0'
            }`}
          >
            <button
              onClick={onToggle}
              className="absolute top-1.5 right-1.5 text-white hover:text-gray-200 transition-all duration-300 p-1 hover:rotate-90 hover:scale-110"
            >
              <X className="w-4 h-4" />
            </button>
            Hurtig Navigation
          </div>

          {/* Navigation Links — All visible, no scroll */}
          <div
            className={`grid grid-cols-1 gap-1.5 p-3 transition-all duration-500 text-xs sm:text-sm ${
              isOpen ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
            }`}
          >
            {navigationSections.map((section, index) => (
              <button
                key={section.id}
                onClick={() => {
                  scrollToSection(section.id);
                  onToggle();
                }}
                className={`p-2 rounded-lg border text-left transition-all duration-300 ${
                  activeSection === section.id
                    ? 'border-cyan-500 bg-cyan-600/20 text-cyan-300'
                    : 'border-blue-700/30 hover:border-cyan-500/50 hover:bg-slate-800/50 text-blue-200'
                }`}
              >
                {index + 1}. {section.label}
              </button>
            ))}
          </div>

          <div
            className={`h-1 bg-gradient-to-r from-cyan-600 to-blue-600 transition-all duration-700 ${
              isOpen ? 'w-full' : 'w-0'
            }`}
          />
        </div>
      </div>
    </>
  );
}
